export default "__VITE_ASSET__JOaoCRj$__"